export default function dynamicInputParse($parse) {
  'ngInject';

  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModel) {
      const parseExpression = $scope.$eval($attrs.dynamicInputParse);
      if (parseExpression) {
        const parsed = $parse(parseExpression);
        $ngModel.$parsers.push((value) => parsed($scope, { value }));
      }
    },
  };
}
